import { render, staticRenderFns } from "./product-order.vue?vue&type=template&id=098b65c6&scoped=true&"
import script from "./product-order.vue?vue&type=script&lang=js&"
export * from "./product-order.vue?vue&type=script&lang=js&"
import style0 from "./product-order.vue?vue&type=style&index=0&id=098b65c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098b65c6",
  null
  
)

export default component.exports